module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-command-bar"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.moreButtons.length > 0) ? _c('mt-button', {
    staticStyle: {
      "margin": "4px"
    },
    on: {
      "click": _vm.showMoreAction
    }
  }, [_vm._v("...")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, _vm._l((_vm.buttons), function(item, index) {
    return _c('mt-button', {
      key: item.id,
      staticClass: "flow-button",
      attrs: {
        "type": item.type
      },
      on: {
        "click": function($event) {
          _vm.clickHandler(item, index, $event)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('mt-actionsheet', {
    attrs: {
      "actions": _vm.moreButtons
    },
    on: {
      "click": _vm.clickHandler
    },
    model: {
      value: (_vm.sheetVisible),
      callback: function($$v) {
        _vm.sheetVisible = $$v
      },
      expression: "sheetVisible"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27faba69","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/command-bar/src/command-bar.vue
// module id = 146
// module chunks = 0